import styled from "styled-components";

export const Wrapper = styled.div`
  text-align: center;
  font-size: large;
`;

export const Input = styled.input`
  border: 1px solid grey;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 20px;
  width: 250px;
`;
